import * as defaultImport from "@splunk/react-ui/Select";
export * from "@splunk/react-ui/Select";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
